import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  Fab,
  Tooltip,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import TalkToAdviser from "../Popups/TalkToAdviser";
import ThankYouPopup from "../Popups/ThankYouPopup";
import LoginScreen from "../login/LoginScreen";
import OTPVerification from "../login/OTPVerification";
import RegisterUser from "../login/RegisterUser";
import WelcomeScreen from "../login/WelcomeScreen";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLeadGeneration } from "../../hooks/useLeadGeneration";
import { toast } from "react-toastify";

const slides = [
  {
    image: {
      mobile: "./banner2Mobile.png",
      tablet: "./banner2Tab.png",
      desktop: "/banner1.png"
    },
    title: "We Help you Find the Right Lender ",
    highlight: "Faster",
    description:
      "Get Pre login Credit Assessment and \nIndicative Sanction letters in Hours"
  },
  {
    image: {
      mobile: "./banner1Mobile.png",
      tablet: "./banner1Tab.png",
      desktop: "/banner3.png"
    },
    title: "No multiple CIBIL Enquiries, ",
    highlight: "No Spamming",
    description:
      "Borrow with Confidence, your data is protected at all times."
  },
  {
    image: {
      mobile: "./banner3Mobile.png",
      tablet: "./banner3Tab.png",
      desktop: "/banner2.png"
    },
    title: "Strategic Financial Advisory for ",
    highlight: "SMEs",
    description:
      "Business plan, Project Reports, Forecasting, Alternate Financing"
  },
  {
    image: {
      mobile: "./banner4Mobile.png",
      tablet: "./banner4Tab.png",
      desktop: "/banner4.png"
    },
    title: "Loan Consultants-Get the best for your  ",
    highlight: "Clients",
    description:
    "Leverage our pre login credit assessment tool and Lender Network"
  },
];

const AutoScrollableImage = ({setTabIndex}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showTalkToAdviser, setShowTalkToAdviser] = useState(false);
  const [showThankYouPopUp, setShowThankYouPopUp] = useState(false);
  const [localShowLoginScreen, setLocalShowLoginScreen] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showOTPVarification, setShowOTPVarification] = useState(false);
  const [showMobileOTP, setShowMobileOTP] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [swiperInstance, setSwiperInstance] = useState(null);
  // const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const tabIndex = useSelector((state) => state.user.tabIndex);
  const userDetail = useSelector((state) => state.user.user);
  const handleLeadGeneration = useLeadGeneration(setShowTalkToAdviser, setShowThankYouPopUp);
  const isAuthenticated = !!(userDetail?.jwtToken || localStorage.getItem("jwtToken"));

  const isLender = userDetail && 
    (userDetail.UserType || userDetail.userType || '').toLowerCase() === 'lender';

  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  // const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const loginModalOpen = localShowLoginScreen || showRegister || showOTPVarification || showWelcome;
    if (swiperInstance && swiperInstance.autoplay) {
      if (loginModalOpen) {
        try { swiperInstance.autoplay.stop(); } catch (e) {toast.error("Error stopping autoplay");}
      } else {
        try { swiperInstance.autoplay.start(); } catch (e) {toast.error("Error starting autoplay");}
      }
    }
  }, [localShowLoginScreen, showRegister, showOTPVarification, showWelcome, swiperInstance]);
  
  const getDeviceImage = (slide) => {
    if (windowWidth <= 600) return slide.image.mobile;
    if (windowWidth <= 960) return slide.image.tablet;
    return slide.image.desktop;
  };

  const handleWhatsappClick = () => {
    window.open('https://wa.me/919220589929', '_blank');
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        position: "relative",
        overflow: "hidden",
        // marginTop: "-1px", 
      }}
    >
      {/* Background Image Slider */}
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        loop
        modules={[Autoplay]}
        onSwiper={(swiper) => setSwiperInstance(swiper)}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        style={{
          width: "100%",
        }}
      >
        {slides.map((slide, index) => {
          return (
            <SwiperSlide 
              key={index}
              style={{
                width: "100%",
                height: "auto",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <img 
                src={getDeviceImage(slide)}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block"
                }}
              />
              
              {/* Dark Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: windowWidth <= 600 ? "rgba(0, 0, 0, 0.45)" : "rgba(0, 0, 0, 0.5)",
                  zIndex: 1,
                }}
              />
              
              {/* Content Box */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: "auto",
                  top: "50%",
                  left: windowWidth <= 600 ? "50%" : windowWidth <= 960 ? "5%" : "5%",
                  transform: windowWidth <= 600 
                    ? "translate(-50%, -50%)" 
                    : windowWidth <= 960 
                      ? "translateY(-50%)" 
                    : "translateY(-50%)",
                  textAlign: windowWidth <= 600 ? "left" : "left",
                  color: "#fff",
                  zIndex: 2,
                  width: windowWidth <= 600 ? "90%" : windowWidth <= 960 ? "90%" : "90%",
                  padding: windowWidth <= 600 ? "12px" : "30px",
                }}
              >
                {/* Title */}
                <Typography
                  variant="h4"
                  sx={{ 
                    fontWeight: "bold", 
                    color: "#FFFFFF", 
                    marginBottom: windowWidth <= 600 ? 1.2 : windowWidth <= 960 ? 1 : 1,
                    fontSize: windowWidth <= 600 ? "0.85rem" : windowWidth <= 960 ? "1.3rem" : "2.2rem",
                    lineHeight: windowWidth <= 600 ? 1.1 : windowWidth <= 960 ? 1.2 : 1.3,
                    maxWidth: windowWidth <= 600 ? "65%" : windowWidth <= 960 ? "100%" : "80%",
                    wordWrap: "break-word",
                    wordBreak: windowWidth <= 600 ? "break-word" : "normal",
                    whiteSpace: windowWidth <= 600 ? "normal" : windowWidth <= 960 ? "pre-line" : "normal",
                    backgroundColor: "transparent"
                  }}
                >
                  {slides[activeIndex].title}
                  <Box component="span" sx={{
                    color: "#18CB96",
                    fontWeight: "bold",
                    display: "inline-block"
                  }}>
                    {slides[activeIndex].highlight}
                  </Box>
                </Typography>

                {/* Description */}
                <Typography
                  variant="body1"
                  sx={{
                    color: "white",
                    lineHeight: windowWidth <= 600 ? 1.3 : windowWidth <= 960 ? 1.3 : 1.5,
                    maxWidth: windowWidth <= 600 ? "60%" : windowWidth <= 960 ? "100%" : "80%",
                    marginBottom: windowWidth <= 600 ? 2 : windowWidth <= 960 ? 2 : 2,
                    whiteSpace: windowWidth <= 600 ? "normal" : windowWidth <= 960 ? "pre-line" : "normal",
                    fontSize: windowWidth <= 600 ? "0.6rem" : windowWidth <= 960 ? "0.8rem" : "1rem",
                    wordWrap: "break-word",
                    overflow: "hidden",
                    wordBreak: windowWidth <= 600 ? "break-word" : "normal",
                    backgroundColor: "transparent" 
                  }}
                >
                  {slides[activeIndex]?.description}
                </Typography>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "column", md: "column" },
                    gap: windowWidth <= 600 ? 1.2 : windowWidth <= 960 ? 1.5 : 2,
                    mt: windowWidth <= 600 ? 1.5 : windowWidth <= 960 ? 2 : 3,
                    alignItems: "flex-start",
                    paddingBottom: windowWidth <= 600 ? 0 : windowWidth <= 960 ? "15px" : "30px",
                  }}
                >
                  {!isLender && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#18CB96",
                        color: "#fff",
                        width: windowWidth <= 600 ? "135px" : windowWidth <= 960 ? "200px" : "250px",
                        py: windowWidth <= 600 ? 0.3 : windowWidth <= 960 ? 0.8 : 1.5,
                        textTransform: "none",
                        fontSize: windowWidth <= 600 ? "0.65rem" : windowWidth <= 960 ? "0.8rem" : "1rem",
                        borderRadius: "4px",
                        "&:hover": { backgroundColor: "#14B384" },
                        whiteSpace: "nowrap"
                      }}
                      startIcon={<PlaylistAddCheckIcon sx={{ fontSize: windowWidth <= 600 ? "0.7rem" : windowWidth <= 960 ? "0.8rem" : "inherit" }} />}
                      onClick={() => {
                        try {
                          window.scrollTo(0, 0);
                          if (activeIndex >= slides.length - 2) {
                            navigate("/sme-advisory");
                          } else {
                            dispatch(setTabIndex(7));
                            navigate("/calculator");
                          }
                        } catch (error) {
                          if (activeIndex >= slides.length - 2) {
                            navigate("/sme-advisory");
                          } else {
                            navigate("/calculator");
                          }
                        }
                      }}
                    >
                      {activeIndex >= slides?.length - 2 ? "Know more" : "Check eligibility"}
                    </Button>
                  )}

                  <Button
                    variant="outlined"
                    sx={{
                      borderColor: "#18CB96",
                      color: "#18CB96",
                      width: windowWidth <= 600 ? "135px" : windowWidth <= 960 ? "200px" : "250px",
                      py: windowWidth <= 600 ? 0.3 : windowWidth <= 960 ? 0.8 : 1.5,
                      textTransform: "none",
                      fontSize: windowWidth <= 600 ? "0.65rem" : windowWidth <= 960 ? "0.8rem" : "1rem",
                      borderRadius: "4px",
                      "&:hover": { borderColor: "#18CB96", color: "#18CB96" },
                      whiteSpace: "nowrap"
                    }}
                    disabled={activeIndex >= slides.length - 1 && isAuthenticated}
                    onClick={() => {
                      if (activeIndex >= slides.length - 1) {
                        setLocalShowLoginScreen(true);
                      } else {
                        handleLeadGeneration();
                      }
                    }}
                    startIcon={<RecordVoiceOverIcon sx={{ fontSize: windowWidth <= 600 ? "0.7rem" : windowWidth <= 960 ? "0.8rem" : "inherit" }} />}
                  >
                    {activeIndex >= slides?.length - 1 ? "Join As Partner" : "Free Consultation"}
                  </Button>
                </Box>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {showTalkToAdviser&&<TalkToAdviser
        showTalkToAdviser={showTalkToAdviser}
        setShowTalkToAdviser={setShowTalkToAdviser}
        setShowThankYouPopUp={setShowThankYouPopUp}
      />}
      {showThankYouPopUp&&<ThankYouPopup
        showThankYouPopUp={showThankYouPopUp}
        setShowThankYouPopUp={setShowThankYouPopUp}
        from="home"
      />}

      {localShowLoginScreen && (
        <LoginScreen
          showLoginScreen={localShowLoginScreen}
          setShowLoginScreen={setLocalShowLoginScreen}
          setShowRegister={setShowRegister}
          setShowOTPVarification={setShowOTPVarification}
          setShowMobileOTP={setShowMobileOTP}
          setRequestData={setRequestData}
          requestData={requestData}
        />
      )}
      {showRegister && (
        <RegisterUser
          showRegister={showRegister}
          setShowRegister={setShowRegister}
          setShowLoginScreen={setLocalShowLoginScreen}
          setShowOTPVarification={setShowOTPVarification}
          setRequestData={setRequestData}
          requestData={requestData}
          setShowMobileOTP={setShowMobileOTP}
        />
      )}
      {showOTPVarification && (
        <OTPVerification
          showOTPVarification={showOTPVarification}
          setShowOTPVarification={setShowOTPVarification}
          showMobileOTP={showMobileOTP}
          setShowWelcome={setShowWelcome}
          setRequestData={setRequestData}
          requestData={requestData}
          redirectToApplyLoan={false}
        />
      )}
      {showWelcome && (
        <WelcomeScreen
          showWelcome={showWelcome}
          setShowWelcome={setShowWelcome}
          requestData={requestData}
          redirectToApplyLoan={false}
        />
      )}

      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 10, sm: 15, md: 20 },
          right: { xs: 10, sm: 15, md: 20 },
          zIndex: 1000,
          width: { xs: 50, sm: 55, md: 60 },
          height: { xs: 50, sm: 55, md: 60 },
        }}
      >
        <Tooltip title="Chat on WhatsApp" placement="left">
          <Fab
            aria-label="whatsapp-chat"
            sx={{
              position: 'static',
              bgcolor: 'transparent',
              boxShadow: 'none',
              '&:hover': {
                bgcolor: 'transparent',
                boxShadow: 'none',
              },
              width: '100%',
              height: '100%',
              minHeight: 'auto',
              p: 0,
            }}
            onClick={handleWhatsappClick}
          >
            <img 
              src="/WhatsappIcon.png" 
              alt="WhatsApp Chat" 
              style={{ width: '100%', height: '100%' }}
            />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default AutoScrollableImage;
